import React from 'react';
import { useTranslation } from 'react-i18next';
import { VerifyAccount } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function VerifyAccountPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('verify-account-component.metatags.title'),
        description: t('verify-account-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.verifyAccount,
        index: false,
    });

    return <VerifyAccount />;
}
